module.exports = __webpack_public_path__ + "img/coconuts-350x184.f9e7cf51.jpg";